import { SearchIcon } from "@heroicons/react/solid"
import { HttpError, useOne } from "@refinedev/core";
import Button from "components/button"
import Input from "components/input"
import Select from "components/select"
import { IOrgIdsItem } from "interfaces";
import { useState } from "react";
import { FIPIX_EVENT_HIDDEN_STATUS, STATUS_OPTIONS } from "utills/constants";

const ALL_OPTION = {value: "", label: "All status"};

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {
  const { data: orgIds, isFetching: isFetchingOrganization } = useOne<
    IOrgIdsItem[],
    HttpError
  >({
    resource: "organization/ids",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const organizationIds = (orgIds?.data ?? []).map((org: IOrgIdsItem) => ({
    value: org.id,
    label: org.name_en,
  }));

  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "is_active", operator: "eq", value: status},
      {field: "hidden", operator: "eq", value: hiddenStatus},
      {field: "organization_id", operator: "eq", value: organizationId},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [status, setStatus] = useState<string>(currentFilterValues.is_active);
  const [hiddenStatus, setHiddenStatus] = useState(currentFilterValues.hidden);
  const [organizationId, setOrganizationId] = useState(currentFilterValues.organization_id);
  const statusArr = [ALL_OPTION].concat(STATUS_OPTIONS);  
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1 md:max-w-md">
        <label htmlFor="name" className="block text-sm font-medium leading-6">
          Search
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            label='Search by Event name'
            id='name'
            type="text"
            placeholder="Search by Event name"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1 md:max-w-56">
        <label htmlFor="organization_id" className="block text-sm font-medium leading-6">
          Organization
        </label>
        <div className="mt-2">
          <Select
            options={organizationIds}
            id="organization_id"
            placeholder="Select Organization"
            className="py-0.5"
            value={organizationIds.find((d) => d.value === organizationId)}
            onChange={(selected: {label: string; value: string} | null) => setOrganizationId(selected?.value ?? "")}
            isClearable
            isLoading={isFetchingOrganization}
          />
        </div>
      </div>
      <div className="flex-1 md:max-w-44">
        <label htmlFor="is_active" className="block text-sm font-medium leading-6">
          Status
        </label>
        <div className="mt-2">
          <Select 
            options={statusArr} 
            id="is_active"
            placeholder="Select Status"
            className="py-0.5"
            value={statusArr.find((d) => d.value === status)}
            onChange={(selected: {label: string; value: string}) => setStatus(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1 md:max-w-44">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          Hidden in list
        </label>
        <div className="mt-2">
          <Select 
            options={FIPIX_EVENT_HIDDEN_STATUS} 
            id="status"
            placeholder="Select Status"
            className="py-0.5"
            value={FIPIX_EVENT_HIDDEN_STATUS.find((d) => d.value === hiddenStatus)}
            onChange={(selected: {label: string; value: string}) => setHiddenStatus(selected?.value)}
          />
        </div>
      </div>

      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}
